import React, { useEffect, useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';
import { useGlobalState } from '../contexts/GlobalStateContext';

const ProfileOptionsModal = ({ user, userId, onClose }) => {
  const { globalState, setViewAsPublic } = useGlobalState();
  const loggedInUsername = globalState.user?.username;
  const [showDialog, setShowDialog] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  const [commentsBlocked, setCommentsBlocked] = useState(false);
  const [messagesBlocked, setMessagesBlocked] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (loggedInUsername && loggedInUsername !== user) {
      checkBlockStatuses();
    }
  }, [userId]);

  const checkBlockStatuses = async () => {
    try {
      const [comments, messages] = await Promise.all([
        fetch('/php/check_comments_block_status.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ blocked_id: userId }),
        }).then(res => res.json()),

        fetch('/php/check_messages_block_status.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ blocked_id: userId }),
        }).then(res => res.json()),
      ]);

      if (comments.status === 'success') setCommentsBlocked(comments.commentsBlocked);
      if (messages.status === 'success') setMessagesBlocked(messages.messagesBlocked);
    } catch (error) {
      console.error('Failed to check block statuses:', error);
    }
  };

  const handleBlockAction = async (type, isBlocked) => {
    const phpEndpoint = `/php/${isBlocked ? 'unblock' : 'block'}_${type}.php`;
    try {
      const response = await fetch(phpEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ blocked_id: userId }),
      });
      const data = await response.json();
      if (data.status === 'success') {
        if (type === 'comments') setCommentsBlocked(!isBlocked);
        if (type === 'messages') setMessagesBlocked(!isBlocked);
        onClose(); // Close modal after successful action
      } else {
        alert(`Failed to ${isBlocked ? 'unblock' : 'block'} ${type}. Please try again.`);
      }
    } catch (err) {
      console.error(`Error blocking/unblocking ${type}:`, err);
    }
  };

  const handleCopyLink = () => {
    const profileLink = `https://www.textalk.city/@${encodeURIComponent(user)}`;
    navigator.clipboard.writeText(profileLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDialogConfirm = () => {
    if (dialogAction === 'blockMessages' || dialogAction === 'unblockMessages') {
      handleBlockAction('messages', dialogAction === 'unblockMessages');
    } else if (dialogAction === 'blockComments' || dialogAction === 'unblockComments') {
      handleBlockAction('comments', dialogAction === 'unblockComments');
    }
    setShowDialog(false);
  };

  const renderButtons = () => {
    const buttons = [];

    if (user === loggedInUsername) {

      buttons.push(
        <button
          key="viewAs"
          className="postOptionsButton button-feature"
          onClick={() => {
            setViewAsPublic(!globalState.viewAsPublic);
          }}
        >
          {globalState.viewAsPublic ? 'Exit View As Public' : 'View As Public'}
        </button>
      );
    } else if (loggedInUsername) {
      buttons.push(
        <button
          key="blockMsg"
          className="postOptionsButton button-report"
          onClick={() => {
            setDialogAction(messagesBlocked ? 'unblockMessages' : 'blockMessages');
            setShowDialog(true);
          }}
        >
          {messagesBlocked ? 'Unblock Messages' : 'Block Messages'}
        </button>
      );

      buttons.push(
        <button
          key="blockComment"
          className="postOptionsButton button-report"
          onClick={() => {
            setDialogAction(commentsBlocked ? 'unblockComments' : 'blockComments');
            setShowDialog(true);
          }}
        >
          {commentsBlocked ? 'Unblock Comments' : 'Block Comments'}
        </button>
      );
    }

    buttons.push(
      <button key="copy" className="postOptionsButton button-feature" onClick={handleCopyLink}>
        {copied ? 'Copied' : 'Copy Link'}
      </button>
    );

    return buttons;
  };


  return (
    <>
      <div id="showPostOptions" className="post-options-modal">
        <div className="post-options-content">
          <span className="closePostOptions" onClick={onClose}>&times;</span>
          <div className="post-options-content">{renderButtons()}</div>
        </div>
      </div>

      <ConfirmationDialog
        show={showDialog}
        action={dialogAction}
        onConfirm={handleDialogConfirm}
        onCancel={() => setShowDialog(false)}
      />
    </>
  );
};

export default ProfileOptionsModal;
